import BaseButtonV1 from './BaseButtonV1';

const BaseButton = ({ ...props }) => {
  return <BaseButtonV1 {...props} />;
};

export default BaseButton;
